import { render, staticRenderFns } from "./ExpCarousel.vue?vue&type=template&id=70182ffa&scoped=true&"
import script from "./ExpCarousel.vue?vue&type=script&lang=ts&"
export * from "./ExpCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ExpCarousel.vue?vue&type=style&index=0&id=70182ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70182ffa",
  null
  
)

export default component.exports